import { useMediaQuery } from 'src/lib/use-media-query'
import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

const BREAKPOINT_RULES: Record<string, string[]> = {
    desktop: ['ottieni'],
    small: ['ottieni', 'tuo'],
}

export const TextHeaderIt = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    let breakBeforeWords = BREAKPOINT_RULES.small

    if (isDesktop) {
        breakBeforeWords = BREAKPOINT_RULES.desktop
    }
    return (
        <HighlightedText
            text="Gratta i biglietti e ottieni il tuo bonus"
            highlights={[
                { word: 'ottieni' },
                { word: 'il' },
                { word: 'tuo' },
                { word: 'bonus' },
            ]}
            breakBeforeWords={breakBeforeWords}
            className={styles.text_header}
        />
    )
}
